export default "__VITE_ASSET__4CMD3ZQ8__"